<template>
    <div>
        <div class="img-thumbnail img-circle">
            <div style="position: relative; padding: 0; cursor: pointer;" type="file">
                <img class="img-circle" style="width: 140px; height: 140px; object-fit: cover;" :src="user.avatar">
                <span style="position: absolute;" @click="openModal">Edit</span>
            </div>
        </div>
        <div class="modal fade modal-avatar modal-custom" id="avatarModal" tabindex="-1" aria-labelledby="avatarModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Upload Foto</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!uploading">
                            <div v-if="!crop">
                                <button class="btn btn-primary main-button pill-button bg-orange" @click="chooseFiles">{{ imgSrc ? 'Change selection' : 'Upload' }}</button>
                                <div class="text-right" v-if="errors.hasOwnProperty('avatar')">
                                    <small class="form-text text-danger">{{ errors['avatar'][0] }}</small>
                                </div>
                                <div class="text-right" v-else>
                                    <small class="form-text text-muted">Maximal size gambar 2MB.</small>
                                </div>
                                <input id="fileUpload" type="file" @change="setImage" accept="image/png, image/jpeg" hidden>
                                <div v-if="imgSrc">
                                    <vue-cropper
                                        ref="cropper"
                                        :aspect-ratio="4 / 4"
                                        :src="imgSrc"
                                        preview=".preview"
                                        :zoomable="false"
                                    />
                                    <div class="mt-1 text-center">
                                        <button class="btn btn-primary" @click.prevent="cropImage">
                                            Replace foto profile
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="text-center">
                                    <label>Image</label>
                                    <br>
                                    <div class="wrap-image">
                                        <img :src="imgSrc" class="img-responsive">
                                        <button class="delete-btn" @click="handleRemoveMedia"><i class="icon icon-close"></i></button>
                                    </div>
                                </div>
                                <div class="button-wrap">
                                    <button class="btn btn-primary main-button pill-button bg-orange" @click="handleSubmit">Simpan</button>
                                    <button class="btn btn-primary main-button pill-button" data-dismiss="modal" aria-label="Close">Batal</button>
                                </div>
                            </div>
                        </div>
                        <div class="text-center" v-else>
                            <pulse-loader color="#EC550E"></pulse-loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from "axios";
import $ from "jquery";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import {DataURIToBlob} from "../UploadHandler";

export default {
    name: "UploadAvatar",
    components: {
        VueCropper,
        PulseLoader
    },
    props: ['user'],
    data() {
        return {
            crop: false,
            upload: false,
            imgSrc: '',
            uploading: false,
            errors: []
        }
    },
    methods: {
        openModal() {
            $('#avatarModal').modal({
                backdrop: 'static',
                keyboard: false
            });
        },
        chooseFiles() {
            document.getElementById("fileUpload").click()
        },
        cropImage() {
            this.imgSrc = this.$refs.cropper.getCroppedCanvas({
                maxWidth: 1000,
                maxHeight: 1000,
            }).toDataURL();
            this.crop = true;
        },
        setImage(e) {
            const file = e.target.files[0];
            if (file.type.indexOf('image/') === -1) {
                this.$notify({
                    duration: 5000,
                    group: 'main',
                    title: 'Oopppss!',
                    text: "Please select an image file",
                    type: 'warn'
                });
                return;
            }
            if (typeof FileReader === 'function') {
                const reader = new FileReader();
                reader.onload = (event) => {
                    if(event.total > 2097152) {
                        this.errors = {
                            "avatar": [
                                "Size gambar melebihi 2MB"
                            ]
                        }
                        this.imgSrc = '';
                        this.crop = false;
                    } else {
                        this.imgSrc = event.target.result;
                        this.crop = false;
                    }
                };
                reader.readAsDataURL(file);
            } else {
                this.$notify({
                    duration: 5000,
                    group: 'main',
                    title: 'Oopppss!',
                    text: "Sorry, FileReader API not supported",
                    type: 'warn'
                });
            }
        },
        handleSubmit() {
            const token = this.$cookies.get('token');
            this.errors = [];
            let formData = new FormData();
            if(this.imgSrc) {
                const file = DataURIToBlob(this.imgSrc)
                formData.append('avatar', file);
            }
            this.uploading = true;
            axios.post('/api/user/change-avatar', formData, { headers: {"Authorization" : `Bearer ${token}`, 'Content-Type': 'multipart/form-data'} })
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                    $('#avatarModal').modal('hide')
                    this.$emit('changed', true)
                    this.crop = false;
                    this.imgSrc = '';
                    this.uploading = false;
                })
                .catch((error) => {
                    this.$emit('changed', false)
                    this.uploading = false;
                    if(error.response) {
                        if(error.response.status === 422) {
                            this.errors = error.response.data.errors
                            this.$notify({
                                duration: 5000,
                                group: 'main',
                                title: 'Oopppss!',
                                text: error.response.data.errors['avatar'][0],
                                type: 'warn'
                            })
                        } else {
                            this.$notify({
                                duration: 5000,
                                group: 'main',
                                title: 'Oopppss!',
                                text: error.response.data.message,
                                type: 'warn'
                            })
                        }
                    }
                });
        },
        handleRemoveMedia() {
            this.imgSrc = '';
            this.crop = false;
        }
    }
}
</script>

<style scoped>
.header-element {
    background-color: #D3D6DB;
    text-align: center;
    margin: 35px 40px 30px 40px;
    padding: 11px;
    border-radius: 30px;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
}
.wrap-edit-profile {
    display: flex;
    margin: auto;
    text-align: center;
    width: 100px;
    height: 100px;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
}
.edit-avatar img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
}
.edit-avatar {
    text-align: center;
    margin-bottom: 25px;
}
.img-circle {
    border-radius: 50%;
}
.img-thumbnail span {
    background: rgba(240,240,240,0.8);
    bottom: 0;
    color: #333;
    left: 0;
    padding: 14px 0;
    text-align: center;
    width: 100%;
    backdrop-filter: saturate(180%) blur(20px);
    font-weight: bold;
}
.img-thumbnail {
    border-radius: 0;
    border: none;
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    background-color: transparent;
}
.img-thumbnail > div {
    display:inline-block;
    overflow: hidden;
    height: 140px;
    border-radius:50%;
}
.wrap-image {
    position: relative;
}
.wrap-image img {
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 50%;
}
.delete-btn {
    position: absolute;
    flex: 1;
    background: transparent;
    border: none;
    left: 60%;
    transform: translate(-50%, 35%);
}
@media only screen and (min-width: 768px) {
    #avatarModal .modal-dialog {
        max-width: 50%;
    }
}
</style>
